import { bindActionCreators } from 'redux';
import * as ReactRedux from 'react-redux';
import HelpSideBar from 'VisualStatic/HelpSideBar';
import * as VisualStaticActions from 'VisualStatic/VisualStaticActions';
import withInit from 'WithInit';
import store from '../../store';

const mapStateToProps = ({ VisualStaticStateHandler }) => (
    { showSideBar: VisualStaticStateHandler.showSideBar }
);

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    ...VisualStaticActions,
  }, dispatch)
);

const HelpSideBarWithRedux = ReactRedux.connect(
  mapStateToProps,
  mapDispatchToProps,
)(HelpSideBar);

export default withInit(HelpSideBarWithRedux, true);

if (window.FormSwift && window.FormSwift.React) {
  const addedActions = Object.assign(
    {},
    VisualStaticActions,
    window.FormSwift.React.actions,
  );
  window.FormSwift.React.actions = addedActions;
} else {
  window.FormSwift = {
    React: {
      store,
      actions: VisualStaticActions,
    },
  };
}



// WEBPACK FOOTER //
// ./src-react/VisualStatic/ConnectedHelpSideBar/index.jsx